export default __webpack_public_path__ + "static/media/ferramenta-baixar-videos-img1.1dad76f2.jpeg";